import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useGlobalStore } from '../services/store/store'

const useNavigationGuard = () => {
	const location = useLocation()
	const updateRoutes = useGlobalStore((state) => state.updateRoutes)

	useEffect(() => {
		updateRoutes(location.pathname)
	}, [location.pathname, updateRoutes])

	return null
}

export default useNavigationGuard
